import { ProjectService } from './../project.service';
import { KnaufMosaicColor } from './../knauf-mosaic-color';
import { KnaufPaletteSetService } from './../knauf-palette-set.service';
import { Component, OnInit } from '@angular/core';
import { Project } from '../project';

@Component({
  selector: 'app-select-mosaic',
  templateUrl: './select-mosaic.component.html',
  styleUrls: ['./select-mosaic.component.sass']
})
export class SelectMosaicComponent implements OnInit {
  title: string = "ZADBAJ O DETALE - TYNK MOZAIKOWY DO COKOŁÓW, SZCZYTÓW I NAROŻY FASAD ORAZ STREFY WEJŚCIOWEJ";
  subtitle: string = "";
  mosaic_set: KnaufMosaicColor[];
  selectedMosaic: KnaufMosaicColor = null;
  next: string = "/what-plaster";
  prev: string = "/finished-project";
  project: Project;
  showMosaicInfo: boolean = false;

  constructor(private palettesService: KnaufPaletteSetService, private projectService: ProjectService) { }
  ngOnInit() {
    this.mosaic_set = this.palettesService.getKnaufMosaicSet();
    this.selectedMosaic = this.projectService.getProject().selectedMosaic;
    this.project = this.projectService.getProject();
  }

  onMosaicSelect(color: KnaufMosaicColor) {
    if (this.selectedMosaic == color) {
      this.selectedMosaic = null;
    } else {
      this.selectedMosaic = color;
    }
    this.projectService.setSelectedMosaic(this.selectedMosaic);
  }

  onMosaicInfo(show: boolean) {
    this.showMosaicInfo = show;
  }
}
